import { Gecko } from '../../Logic';
import NewChatAccountPage from './';

export default {
    name: 'new-chat-account',
    url: '/new-chat-account',
    component: NewChatAccountPage
};